class SubmissionContants {
    static FILE_TYPE_ASSET = 'Asset';
    static FILE_TYPE_PAR_FORM = 'PAR Form';
    static FILE_TYPE_JOB_HISTORY = 'Job History';
}

export default SubmissionContants;